import type { SkillId } from './skills';
import { skillBoards } from './skillBoards';

export interface TunnelPanelDef {
  id: SkillId;
  name: string;
  wall: 'left' | 'right';
  /** Distance along tunnel from entrance (meters toward exit). */
  z: number;
  lines: string[];
  percent: number;
  accent: string;
}

/** Glass skill displays — derived from skillBoards content. */
export const TUNNEL_PANELS: TunnelPanelDef[] = skillBoards.map((b) => ({
  id: b.id,
  name: `${b.title} ${b.subtitle}`.replace(/\s+/g, ' ').trim(),
  wall: b.wall,
  z: b.z,
  lines: b.skills.slice(0, 3),
  percent: b.progress,
  accent: b.color,
}));

export const TUNNEL_MILESTONES_EARLY = [
  'FIRST COMMIT',
  'FIRST CLIENT',
  'FIRST DEPLOYMENT',
  'FIRST INTERNSHIP',
  'FIRST HACKATHON',
  'FIRST PRODUCTION RELEASE',
];

export const TUNNEL_MILESTONES_LATE = [
  'SCALABILITY',
  'MICROSERVICES',
  'GENERATIVE AI',
  'AGENTIC AI',
  'SYSTEM DESIGN',
  'PRODUCTION',
];

/** Exit threshold — extra run after the last skill card so it stays readable. */
export const TUNNEL_EXIT_Z = 37;
/** Floor circle the player must stand on to trigger blackout + VO. */
export const EXIT_CHECKPOINT_Z = TUNNEL_EXIT_Z - 7.5;
export const EXIT_CHECKPOINT_RADIUS = 0.82;
/** Walk clamp slightly past the mark so you can stand in the center. */
export const EXIT_FP_STOP_Z = EXIT_CHECKPOINT_Z + EXIT_CHECKPOINT_RADIUS + 0.12;
/** Hero stays near handoff; only a tiny drift toward the mouth. */
export const EXIT_WALK_END_Z = TUNNEL_EXIT_Z - 5.8;
/** Initial shoulder-cam distance (player ~35–40% frame). */
export const EXIT_CAM_FOLLOW_Z = 3.05;
/** Start further back so the first right-wall board is fully framed. */
export const TUNNEL_START_Z = -4.5;
/** Shell extends behind the start so the camera isn't outside the tunnel. */
export const TUNNEL_BACK_Z = TUNNEL_START_Z - 2;
